
import React, { useState, useEffect } from "react";
import "./Schedule.css";
import { useNavigate } from "react-router-dom";
import { getAllSchedule, getAllHolidays } from "../../api";
import { useGlobalContext } from "../../context";
import Pagination from "../../Components/Pagination/Pagination";
import chunk from "chunk";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import ScheduleDelete from "./ScheduleDelete";

function Schedule() {

    const {
        concretSchedule,
        setConcretSchedule,
        setOpenDeleteSchedule,
    } = useGlobalContext()

    const navigate = useNavigate();
    const [allSchedule, setAllSchedule] = useState([]);
    const [allHolidays, setAllHolidays] = useState([]);
    const [showSchedule, setShowSchedule] = useState([]);
    const [scheduleChunkData, setScheduleChunkData] = useState([]);
    const [tableData, setTableData] = useState([]);

    const getScheduls = async () => {
        const scheduleData = await getAllSchedule();
        setAllSchedule(scheduleData.data);
    }

    const getHolidays = async () => {
        const holidayData = await getAllHolidays();
        setAllHolidays(holidayData.data);
    }

    useEffect(() => {
        getScheduls();
    }, [])

    useEffect(() => {
        setShowSchedule(allSchedule.concat(allHolidays));
    }, [allSchedule, allHolidays])

    useEffect(() => {
        setScheduleChunkData(chunk(showSchedule,20));
    }, [showSchedule])

    const timeUpdater = (value) => {
        return new Date(value).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
        });
    }

    const goToDeleteWindow = async (item) => {
        await setConcretSchedule(item);
        setOpenDeleteSchedule(true);
    }

    const goToEditSchedule = (item) => {
        navigate("/edit-schedule", { state: item });
    }

    return(
        <div className = "Schedule">
            <div className="scheduleMainBox">
                <div
                    className = "usersTableHeaderBox"
                    style = {{
                        width: "95%",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <h3 className = "usersTableHeaderText">
                        SCHEDULE
                    </h3>
                </div>
                <div className = "schedulePostsSchedulsBox">
                    {
                        tableData?.map((item, index) =>
                            <div className="schedulePostBox" key = {index}>
                                <div className="schedulePostColumnBox">
                                    <span className="concretScheduleDateBox">
                                        { timeUpdater(item.scheduleDate || item.postDate) }
                                    </span>
                                    <span className = "concretScheduleCategoryBox">
                                        {
                                            item.category ? item.category.replaceAll("_", " ") : item.scheduleType ? item.scheduleType : "HOLIDAY"
                                        }
                                    </span>
                                    <span className="concretScheduleClientsNameBox">
                                        {
                                            item.scheduleType && item.scheduleType === "CLIENT" ?
                                                item.clients.map((client) => {
                                                    return <span>{client?.fullName}</span>
                                                })
                                                :
                                                null
                                        }
                                    </span>
                                </div>
                                <div className="schedulePostColumnBox schedulePostRightBox">
                                    <span className="schedulePostImageBox">
                                        {
                                            item.attachments.map((item, index) => {
                                                if (index < 2) {
                                                    return <img src = { item } className="schedulePostImage" alt = ""/>
                                                }
                                                else {
                                                    return;
                                                }
                                            })
                                        }
                                    </span>
                                    <span className="schedulePostIconsBox">
                                        {
                                            item.scheduleId ?
                                                <BorderColorIcon
                                                    style = {{
                                                       margin: "0 20px",
                                                    }}
                                                    onClick = { goToEditSchedule.bind(this, item) }
                                                />
                                                : null
                                        }
                                        <DeleteIcon
                                            onClick = { goToDeleteWindow.bind(this, item) }
                                        />
                                    </span>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
            <Pagination
                chunkData = {scheduleChunkData}
                setTableData = {setTableData}
            />
            {
                concretSchedule &&
                    <ScheduleDelete
                        getScheduls = {getScheduls}
                    />
            }
        </div>
    )
}

export default Schedule

